import './TeamHeader.css'

export default function TeamHeader({title, subtitle, secondSubtitle}) {
   return (
      <div className="teamHeader-container">
         <h2 className="teamHeader-title">{title}</h2>
         <p className='teamHeader-paragraph'>{subtitle}</p>
         <p className='teamHeader-paragraph'>{secondSubtitle}</p>
      </div>
   )
}
